<template>
  <div class="wrapper">
    <p>
      Lors de chaque événement de l'association, vous avez la possibilité d'annoncer un jeu que vous souhaitez apporter ou de vous positioner sur une table annoncée par un autre membre de l'association.
    </p>
    
    <h3 ref="#inscription">S'inscrire à un jeu</h3>
    <p>
      Vous pouvez réserver votre place pour l'un des jeux proposé par un autre membre en cliquant sur le petit "+" à coté du jeu
    </p>
    <img src="@/assets/help-subscribe.png" width="500" @load="loaded" />
    
    <p>
      Le site ne permet que de faciliter l'organisation de nos rencontres, si vous changez d'avis quant à votre participation à un jeu, cliquez sur le bouton "se désinscrire"
    </p>
    <img src="@/assets/help-unsubscribe.png" width="500" @load="loaded" />
    
    <hr/>
    <h3 ref="#annonces">Annoncer un jeu</h3>
    <p>
      Vous pouvez proposer un jeu en cliquant sur le bouton "Proposer un jeu".<br>
      Il ne vous reste plus qu'à indiquer le nom du jeu, le nombre minimum et maximum de joueurs que vous souhaitez accueillir a votre table ainsi qu'une image du jeu.<br>
    </p>
    <img src="@/assets/help-newboard.png" width="300"  @load="loaded"/>
    
    <hr/>
    <h3 ref="#modifier_annonces">Modifier ou annuler une annonce</h3>
    <p>
      Vous pouvez modifier ou annuler une annonce de jeu en cliquant sur le bouton "modifier" sous l'image du jeu.<br>
    </p>
    <img src="@/assets/help-editboard.png" width="250"  @load="loaded" />
    
    <hr/>
    <h3 ref="#email">Gérer les notifications par E-mail</h3>
    <p>
      Vous pouvez activer ou désactiver les inscriptions aux emails depuis votre page de profil.<br>
    </p>
    <img src="@/assets/help-notifs-profile.png" width="250"  @load="loaded"/><br>
    <img src="@/assets/help-notifs-unsubscribe.png" width="250"  @load="loaded"/>
    
    <div style="height:500px"></div>
  </div>
</template>

<script>
import Vue from 'vue'
export default {
  name: 'HelpPage',
  data: function(){
    return {
      toLoad: 6,
    }
  },
  methods: {
    scrollMeTo(refName) {
      var element = this.$refs[refName]
      var top = element.offsetTop
      window.scrollTo(0, top)
    },
    loaded(){
      this.toLoad--
      if(this.toLoad == 0){
        if (this.$route.hash) {
          setTimeout(() => this.scrollMeTo(this.$route.hash), 100)
        }
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.wrapper{
  margin: 20px;
}

</style>
